import type { AttachmentUploadDataDto, AttachmentUploadDto, Configuration, IRequest, SendContestationDto, SendContestationResponseDto, SendMessageThreadDto } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';

/** Tickets da Área do Cliente (efop-sm via /crm/sm). Financeiro fica em BusinessManagerRequester (/erp/sm). */
export class CustomerTicketsRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public getTicketTableData = async (companyId: string): Promise<any | null> => {
    const requestData: IRequest = {
      endpoint: 'tickets/list',
      method: HttpMethod.GET,
      params: {
        idCompany: companyId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public getConversationTicketData = async (ticketId: string, companyId: string): Promise<any | null> => {
    const requestData: IRequest = {
      endpoint: '/tickets/detail',
      method: HttpMethod.GET,
      params: {
        idCompany: companyId,
        ticketId: ticketId,
      },
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public uploadFileAttachment = async (fileBody: AttachmentUploadDto, companyId: string): Promise<AttachmentUploadDataDto> => {
    const requestData: IRequest = {
      endpoint: '/tickets/upload/attachment',
      method: HttpMethod.POST,
      params: {
        idCompany: companyId,
      },
      body: JSON.stringify(fileBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public sendMessageToThread = async (messageBody: SendMessageThreadDto, companyId: string): Promise<void> => {
    const requestData: IRequest = {
      endpoint: '/ticket/conversation',
      method: HttpMethod.POST,
      params: {
        idCompany: companyId,
      },
      body: JSON.stringify(messageBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
  public sendContestation = async (contestationBody: SendContestationDto): Promise<SendContestationResponseDto> => {
    const requestData: IRequest = {
      endpoint: '/ticket/contestacao',
      method: HttpMethod.POST,
      body: JSON.stringify(contestationBody),
    };

    const response = await this.requester.request(requestData);
    return response.data;
  };
}
